window.addEventListener('DOMContentLoaded', () => {
    const tocLinks = document.querySelectorAll('.toc__list li a');
    const headings = document.querySelectorAll('h2.has-anchor[id]'); // Only H2 headings

    if (headings.length === 0) return; // Exit if no headings found

    const pluginObserver = new IntersectionObserver(entries => {
        // Remove all active states first
        tocLinks.forEach(link => {
            link.parentElement.classList.remove('is-active');
        });

        let activeId = null;
        let maxRatio = 0;

        // Find the H2 heading with the highest intersection ratio
        entries.forEach(entry => {
            if (entry.isIntersecting && entry.intersectionRatio > maxRatio) {
                maxRatio = entry.intersectionRatio;
                activeId = entry.target.getAttribute('id');
            }
        });

        // Fallback: find the H2 heading closest to the top
        if (!activeId) {
            let closestDistance = Infinity;
            headings.forEach(heading => {
                const rect = heading.getBoundingClientRect();
                const distance = Math.abs(rect.top);
                if (distance < closestDistance) {
                    closestDistance = distance;
                    activeId = heading.getAttribute('id');
                }
            });
        }

        // Add active class to the current section only
        if (activeId) {
            const activeLink = document.querySelector(`.toc__list li a[href="#${activeId}"]`);
            if (activeLink) {
                activeLink.parentElement.classList.add('is-active');
            }
        }
    }, {
        rootMargin: '-120px 0px -50% 0px',
        threshold: [0, 0.5, 1]
    });

    // Observe all headings with IDs
    headings.forEach(heading => {
        pluginObserver.observe(heading);
    });
});
